import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { Col, Row, Button } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const FormInvoiceData = ({
    typeBusiness,
    money,
    paymentConcept,
    paymentMethod,
    invoiceEndDate,
    handleTypeBusiness,
    handleMoney,
    handlePaymentMethod,
    handlePaymentConcept,
    handleInvoiceEndDate,
    errors
}) => {

    useEffect(() => {
    }, []);

    return (
        <Row>
            <Col md={6}>
                <TextField
                    className="medical-material-form__field"
                    select
                    name="typeBusiness"
                    id="typeBusiness"
                    label="Tipo de Negociación"
                    value={typeBusiness}
                    onChange={(e) => {
                        handleTypeBusiness(e.target.value);
                    }}
                    error={errors.hasOwnProperty("typeBusiness") && (typeBusiness == "" || typeBusiness == null || typeBusiness == undefined) ? errors.typeBusiness !== "" : false}
                    helperText={errors.typeBusiness}
                >
                    <MenuItem key={1} value={"CREDITO"}>CREDITO</MenuItem>
                    <MenuItem key={2} value={"CONTADO"}>CONTADO</MenuItem>
                    <MenuItem key={3} value={"POR EVENTO"}>POR EVENTO</MenuItem>
                    <MenuItem key={4} value={"CAPITACIÓN"}>CAPITACIÓN</MenuItem>
                    <MenuItem key={5} value={"PGP"}>PGP</MenuItem>
                </TextField>
            </Col>
            {/* <Col md={6}>
                <TextField
                    className="medical-material-form__field"
                    type="number"
                    name="copago"
                    id="copago"
                    label="Copago"
                    value={money}
                    onChange={(e) => {
                        handleMoney(e.target.value);
                    }}
                    error={errors.hasOwnProperty("money") && (money == "" || money == null || money == undefined) ? errors.money !== "" : false}
                    helperText={errors.money}
                />
            </Col> */}
            <Col md={6}>
                <TextField
                    select
                    label="Medio de Pago"
                    name="method"
                    value={paymentMethod}
                    onChange={(event) => {
                        handlePaymentMethod(event.target.value)
                    }}
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }
                    }}
                    required={true}
                    autoFocus
                    error={errors.hasOwnProperty("paymentMethod") && (paymentMethod == "" || paymentMethod == null || paymentMethod == undefined) ? errors.paymentMethod !== "" : false}
                    helperText={errors.paymentMethod}
                >
                    <MenuItem key={1} value={'Efectivo'}>
                        Efectivo
                    </MenuItem>
                    <MenuItem key={2} value={'Tarjeta'}>
                        Tarjeta
                    </MenuItem>
                </TextField>
            </Col>
            <Col md={6}>
                <TextField
                    select
                    label="Concepto"
                    name="concept"
                    value={paymentConcept}
                    onChange={(event) => {
                        handlePaymentConcept(event.target.value);
                    }}
                    style={{ width: '100%' }}
                    className="medical-material-form__field"
                    InputLabelProps={{
                        style: { color: '#646777' }
                    }}
                    required={true}
                    autoFocus
                    error={errors.hasOwnProperty("paymentConcept") && (paymentConcept == "" || paymentConcept == null || paymentConcept == undefined) ? errors.paymentConcept !== "" : false}
                    helperText={errors.paymentConcept}
                >
                    <MenuItem key={1} value={'COPAGO'}>
                        COPAGO
                    </MenuItem>
                    <MenuItem key={2} value={'CUOTA MODERADORA'}>
                        CUOTA MODERADORA
                    </MenuItem>
                    <MenuItem key={3} value={'EXCEDENTES'}>
                        EXCEDENTES
                    </MenuItem>
                    <MenuItem key={4} value={'SERVICIOS DE SALUD'}>
                        SERVICIOS DE SALUD
                    </MenuItem>
                    <MenuItem key={5} value={'PARTICULAR'}>
                        PARTICULAR
                    </MenuItem>
                </TextField>
            </Col>
            <Col md={6}>
                <MuiPickersUtilsProvider utils={MomentUtils} >
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <DatePicker
                            disablePast
                            label="Fecha de Vencimiento"
                            value={invoiceEndDate}
                            onChange={(date) => {
                                handleInvoiceEndDate(date);
                            }}
                            format="yyyy/MM/DD"
                            animateYearScrolling
                            className="material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                            style={{ width: '100%' }}
                            error={errors.hasOwnProperty("invoiceEndDate") && (invoiceEndDate == "" || invoiceEndDate == null || invoiceEndDate == undefined) ? errors.invoiceEndDate !== "" : false}
                            helperText={errors.invoiceEndDate}
                        />
                    </ThemeProvider>
                </MuiPickersUtilsProvider>
            </Col>
        </Row >
    );
};
export default FormInvoiceData;
